import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../../PanelPage";
import {HappyFaceIcon} from "../../../../../../core/ui/SVGElements.jsx";
import {Messages} from "../../../../../Messages";
import {dismissFlowSuccess} from "../../../../../widget/misc/WidgetUtils";
import {SubscriptionCoveragePerk} from "../../subscribe/components/CoverageDescriptionElements";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {DonationSuccessPanelStyle} from "../DonationSuccessPanel";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../../blink-sdk/Constants";
import {iFrameState} from "../../../../../services/IFrameState";
import {BlinkButton} from "../../../../../../core/ui/Button.jsx";


@registerStyle(DonationSuccessPanelStyle)
export class EditDonationSuccessPanel extends BasePanelPage {
    getEditDonationMessage() {
        const donation = iFrameUserDataService.getActiveRecurringDonation();

        return Messages.editDonationSuccessText1(donation.formatPrice());
    }

    getGuidelines() {
        if (iFrameState.forceHideWallet) {
            return []
        }

        return [
            <SubscriptionCoveragePerk text={Messages.editDonationSuccessGuideline1}/>,
            <SubscriptionCoveragePerk text={Messages.editDonationSuccessGuideline2}/>,
        ];
    }

    render() {
        const {styleSheet} = this;

        return [
            !iFrameMerchantService.isMerchant(TNR_ALIAS) && <HappyFaceIcon className={styleSheet.icon}/>,
            <div className={styleSheet.title}>{Messages.editDonationSuccessTitle}</div>,
            <MessageElement className={styleSheet.message} message={this.getEditDonationMessage()}/>,
            <div className={styleSheet.message}>{Messages.editDonationSuccessText2}</div>,
            this.getGuidelines(),
            <BlinkButton className={styleSheet.actionButton} onClick={dismissFlowSuccess}>
                {Messages.ok}
            </BlinkButton>,
        ];
    }
}
